import { useMutation } from '@apollo/client';
import { DELETE_CATEGORY_MUTATION } from '../../mutations';

export function useDeleteCategoryMutation() {
    return useMutation( DELETE_CATEGORY_MUTATION );
}
